import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Scope } from 'informed';
import { get } from 'lodash-es';

import HiddenField from '../../Common/HiddenField';
import Switch from '../../Common/SwitchFieldMU';
import LegalPartyFields from './LegalPartyFields';
import NaturalPartyFields from './NaturalPartyFields';

class PartyFields extends Component {
  constructor(props) {
    super(props);
    const subscriberKind = get(props, 'subscriberKind', 'all');
    let isPerson = get(props, 'formState.values.transform.party.is_person', true);
    switch (subscriberKind) {
      case 'company':
        isPerson = false;
        break;

      default:
        break;
    }
    this.state = {
      isPerson,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { formState } = nextProps;
    const subscriberKind = get(nextProps, 'subscriberKind', 'all');
    const { isPerson } = prevState;
    // const { binder } = prevState;
    let newState = null;
    if (get(formState, 'values.transform.party.is_person', true) !== isPerson) {
      newState = {
        isPerson: subscriberKind === 'company' ? false : get(formState, 'values.transform.party.is_person', true),
      };
    }
    return newState;
  }

  render() {
    const { config, strings, readOnly, subscriberKind } = this.props;
    const { isPerson } = this.state;
    // console.log('PartyFields', isPerson, formState);

    const handlePersonTypeChange = e => {
      this.setState({ isPerson: get(e, 'target.value') === 'natural' });
    };

    const partyTypeFiled = () => {
      switch (subscriberKind) {
        case 'all': {
          return (
            <Switch
              className="field select"
              key="is_person"
              field="is_person"
              id="select-is_person"
              name="is_person"
              shrink
              label={
                isPerson
                  ? get(strings, 'block.covered.party.field.is_person.natural.label', 'Personne Physique')
                  : get(strings, 'block.covered.party.field.is_person.legal.label', 'Personne Morale')
              }
              //   options={[{ value: 'true', text: 'Personne Physique' }, { value: 'false', text: 'Personne Morale' }]}
              initialValue={isPerson}
              onChange={handlePersonTypeChange}
              disabled={readOnly}
              required
            />
          );
        }
        case 'company': {
          return (
            <div className="hiddenFieldLabeled">
              <span className="label">
                {get(strings, 'block.covered.party.field.is_person.legal.label', 'Personne Morale')}
              </span>
              <HiddenField field="is_person" initialValue={false} />
            </div>
          );
        }
        case 'person': {
          return (
            <div className="hiddenFieldLabeled">
              <span className="label">
                {get(strings, 'block.covered.party.field.is_person.natural.label', 'Personne Physique')}
              </span>
              <HiddenField field="is_person" initialValue />
            </div>
          );
        }

        default: {
          return (
            <Switch
              className="field select"
              key="is_person"
              field="is_person"
              id="select-is_person"
              name="is_person"
              shrink
              label={
                isPerson
                  ? get(strings, 'block.covered.party.field.is_person.natural.label', 'Personne Physique')
                  : get(strings, 'block.covered.party.field.is_person.legal.label', 'Personne Morale')
              }
              initialValue={isPerson}
              onChange={handlePersonTypeChange}
              disabled={readOnly}
              required
            />
          );
        }
      }
    };

    return (
      <>
        <Scope scope="party">{partyTypeFiled()}</Scope>
        {isPerson ? (
          <NaturalPartyFields config={config} strings={strings} readOnly={readOnly} />
        ) : (
          <LegalPartyFields config={config} strings={strings} readOnly={readOnly} />
        )}
      </>
    );
  }
}

PartyFields.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.any.isRequired, // eslint-disable-line
  // eslint-disable-next-line react/forbid-prop-types
  strings: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  config: PropTypes.any.isRequired,
  readOnly: PropTypes.bool.isRequired,
  subscriberKind: PropTypes.string,
};
PartyFields.defaultProps = {
  subscriberKind: 'all',
};

export default PartyFields;
